import styled from "styled-components";

export const SAddMemberModalSection = styled.div`
  padding-bottom: 24px;
`;
